var _title, _circle, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGradientActiveMark = function SvgGradientActiveMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Circle with dot inside")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none",
    stroke: "url(#paint0_linear_903_1210)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2941,
    cy: 15.2941,
    r: 5.29412,
    fill: "url(#paint1_linear_903_1210)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_903_1210",
    x1: -5.43932e-8,
    y1: 13.6028,
    x2: 41.6683,
    y2: 14.0412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_903_1210",
    x1: 10,
    y1: 14.801,
    x2: 24.7065,
    y2: 14.9557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A4DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2994A"
  })))));
};
export { SvgGradientActiveMark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHRpdGxlPkNpcmNsZSB3aXRoIGRvdCBpbnNpZGU8L3RpdGxlPgo8Y2lyY2xlIGN4PSIxNSIgY3k9IjE1IiByPSIxNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXJfOTAzXzEyMTApIiBzdHJva2Utd2lkdGg9IjIiLz4KPGNpcmNsZSBjeD0iMTUuMjk0MSIgY3k9IjE1LjI5NDEiIHI9IjUuMjk0MTIiIGZpbGw9InVybCgjcGFpbnQxX2xpbmVhcl85MDNfMTIxMCkiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl85MDNfMTIxMCIgeDE9Ii01LjQzOTMyZS0wOCIgeTE9IjEzLjYwMjgiIHgyPSI0MS42NjgzIiB5Mj0iMTQuMDQxMiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNkE0REJDIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0YyOTk0QSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfOTAzXzEyMTAiIHgxPSIxMCIgeTE9IjE0LjgwMSIgeDI9IjI0LjcwNjUiIHkyPSIxNC45NTU3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiM2QTREQkMiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRjI5OTRBIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";